import {Injectable} from "@angular/core";
import { AuthenticationService } from "@ispm/user/services/authentication.service";
import {cloneDeep, get, has} from 'lodash';
import moment from 'moment';
const ADAPTABLE_FILTERS = 'adaptableFilters';
const CONDITION_CURRENT_USER_ID = '{currentUserId}';
const CONDITION_CURRENT_USER_NPI_ID = '{currentUserNPI}';
const CONDITION_TODAY_START = '{todayStart}';
const CONDITION_TODAY = '{today}';
const CONDITION_NOW = '{now}';

export const DEFAULT_TARGET = {
  "target": {
    "_page": 0,
    "_count": "$(chunkSize)",
    "_fieldslist": "id"
  }
};

@Injectable()
export class AdaptiveFilterService {

  private currentUserId: string;
  private currentUserIdentifiers: any[];

  constructor(private authService: AuthenticationService) {
    if (this.authService.user) {
      this.currentUserId = this.authService.user.info.id;
      this.currentUserIdentifiers = this.authService.user.info.identifier;
    }
  }

  public getFilter(srcFilter) {
    let f = Object.assign(srcFilter);
    switch (srcFilter.value) {
      case CONDITION_CURRENT_USER_ID:
        f.value = f.value.replace(CONDITION_CURRENT_USER_ID, this.currentUserId);
        break;
      case CONDITION_CURRENT_USER_NPI_ID:
        if(this.currentUserIdentifiers.some(item => item.type.text == 'NPI')) {
          const  userNpiId = this.currentUserIdentifiers.find(item => item.type.text == 'NPI').value;
          f.value = f.value.replace(CONDITION_CURRENT_USER_NPI_ID, userNpiId);
        }
        break;
      case CONDITION_TODAY_START:
        f.value = f.value.replace(CONDITION_TODAY_START, moment().startOf('day').toISOString());
        break;
      case CONDITION_TODAY:
        f.value = f.value.replace(CONDITION_TODAY, moment().format('YYYY-MM-DD'));
        break;
      case CONDITION_NOW:
        f.value = f.value.replace(CONDITION_NOW, moment().format('YYYY-MM-DDTHH:mm:ss'));
      default:
        break;
    }
    return f;
  }

  public getFilterByCategoryAndData(adaptableFilters: any, category: string, currentFilter: any[]) {
    let newFilters: any[] = [];

    if (!!adaptableFilters && !!currentFilter && has(adaptableFilters, category)) {
      let filterNames: string[] = [''];
      if (currentFilter.length > 0 && has(currentFilter[0].attributes, ADAPTABLE_FILTERS)) {
        filterNames = get(currentFilter[0].attributes, ADAPTABLE_FILTERS);
      }
      // find default filter, where name is empty
      const categoryFilters: Array<any> = get(adaptableFilters, category, []);
      if (categoryFilters.length > 0) {
        filterNames.forEach(filterName => {
          let descrForCurrentFilter: any[] = categoryFilters.find(f => f.name === filterName);
          if (!!descrForCurrentFilter) {
            get(descrForCurrentFilter, 'filters', []).forEach(adaptiveFilter => {
              newFilters.push(this.getFilter(adaptiveFilter));
            });
          }
        });
      }
    }
    return cloneDeep(newFilters);
  }

  public getDescriptionByCategoryAndData(dataType: string, adaptableFilters: any, category: string, currentFilter: any[], defaultValue: any = []) {
    return this.findData(adaptableFilters, category, currentFilter, dataType, defaultValue);
  }

  public getCurrentFilterName(appliedFilterProperties: Array<any>) {
    let filterName = '';
    if (!!appliedFilterProperties && appliedFilterProperties.length > 0) {
      let filterNames = get(appliedFilterProperties[0], 'attributes.adaptableFilters', []);
      filterName = filterNames && filterNames.length > 0 ? filterNames[0] : '';
    }
    return filterName;
  }

  private findData(adaptableFilters: any, category: string, currentFilter: any[], dataType: string, defaultValue: any = []) {
    let newDatas = defaultValue;
    if (!!adaptableFilters && !!currentFilter && has(adaptableFilters, category)) {
      let filterNames: string[] = [''];
      if (currentFilter.length > 0 && has(currentFilter[0].attributes, ADAPTABLE_FILTERS)) {
        filterNames = get(currentFilter[0].attributes, ADAPTABLE_FILTERS);
      }
      const categoryFilters: Array<any> = get(adaptableFilters, category, []);
      if (categoryFilters.length > 0) {
        filterNames.forEach(filterName => {
          let descrForCurrentFilter: any[] = categoryFilters.find(f => f.name === filterName);
          if (!!descrForCurrentFilter && has(descrForCurrentFilter, dataType)) {
            newDatas = get(descrForCurrentFilter, dataType, []);
          }
        });
      }
      return cloneDeep(newDatas);
    }
  }

}
